import type {
  RecordClientOperation,
  RecordStrategy,
  RecordStrategyArgs as RecordClientArgs,
  SbRecordType,
  SbRecordData,
} from '../types'
import {
  SpacesRecord,
  SpaceRecord,
  StoriesRecord,
  AppsRecord,
  ComponentsRecord,
  AssetsRecord,
  BlocksRecord,
  DatasourcesRecord,
  QuickFiltersRecord,
} from './records'
import { StoryRecord } from './story'

export class RecordFactory {
  static getRecord(type: SbRecordType): RecordStrategy {
    // This record cases can be replaced with route names.
    switch (type) {
      case 'spaces':
        return new SpacesRecord()
      case 'space':
        return new SpaceRecord()
      case 'story':
        return new StoryRecord()
      case 'stories':
        return new StoriesRecord()
      case 'apps':
        return new AppsRecord()
      case 'components':
        return new ComponentsRecord()
      case 'assets':
        return new AssetsRecord()
      case 'quick_filters':
        return new QuickFiltersRecord()
      case 'blocks':
        return new BlocksRecord()
      case 'datasources':
        return new DatasourcesRecord()
      default:
        throw new Error('Unsupported record type')
    }
  }
}

export class RecordClient {
  private record: RecordStrategy
  constructor(type: SbRecordType) {
    this.record = RecordFactory.getRecord(type)
  }
  async execute(
    operation: RecordClientOperation = 'get',
    args: RecordClientArgs,
  ): Promise<void | SbRecordData | SbRecordData[]> {
    if (operation === 'set') {
      this.record[operation]!(args)
      return
    }
    if (operation === 'remove') {
      this.record[operation]!()
      return
    }

    return await this.record[operation]!()
  }
}
